import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { ufologger } from '@atlassian/ufo-experimental';
import { getPerformanceObject, getPerformanceObserverObject } from '../../utils/window-helper';
export var resourceTimingBuffer = {
  timings: [],
  maxSize: 1000,
  observer: null,
  transformResource: function transformResource(entry) {
    return {
      name: entry.name,
      initiatorType: entry.initiatorType,
      transferSize: entry.transferSize,
      startTime: Math.round(entry.startTime),
      duration: Math.round(entry.duration),
      fetchStart: Math.round(entry.fetchStart || 0),
      workerStart: Math.round(entry.workerStart || 0),
      responseStart: Math.round(entry.responseStart || 0)
    };
  },
  start: function start() {
    var _performance$getEntri;
    var performance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getPerformanceObject();
    var PerformanceObserver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getPerformanceObserverObject();
    if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') {
      return;
    }
    if (resourceTimingBuffer.observer) {
      ufologger.warn('Observer is already running');
      return;
    }
    var resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
    if (resources) {
      resourceTimingBuffer.timings = resources.map(function (resource) {
        return resourceTimingBuffer.transformResource(resource);
      });
    }
    resourceTimingBuffer.observer = new PerformanceObserver(resourceTimingBuffer.addTimings);
    resourceTimingBuffer.observer.observe({
      entryTypes: ['resource']
    });
  },
  stop: function stop() {
    if (resourceTimingBuffer.observer) {
      resourceTimingBuffer.observer.disconnect();
      resourceTimingBuffer.observer = null;
    }
    resourceTimingBuffer.timings = [];
  },
  addTimings: function addTimings(list) {
    var _resourceTimingBuffer;
    var entries = list.getEntries().map(function (entry) {
      return resourceTimingBuffer.transformResource(entry);
    });
    var overflow = resourceTimingBuffer.timings.length + entries.length;
    if (overflow > resourceTimingBuffer.maxSize) {
      var fieldsToRemove = overflow - resourceTimingBuffer.maxSize;
      resourceTimingBuffer.timings.splice(0, fieldsToRemove);
    }
    (_resourceTimingBuffer = resourceTimingBuffer.timings).push.apply(_resourceTimingBuffer, _toConsumableArray(entries));
  }
};
export var getResourceTimings = function getResourceTimings(startTime) {
  var performance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getPerformanceObject();
  if (!PerformanceObserver || !resourceTimingBuffer.observer) {
    var resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
    if (resources) {
      return resources.filter(function (timing) {
        return timing.startTime >= startTime;
      });
    }
    return null;
  }
  return resourceTimingBuffer.timings.filter(function (timing) {
    return timing.startTime >= startTime;
  });
};